import { FunctionComponent, h } from 'preact';

interface Props {
	color: string;
}

const DriverMarkerSVG: FunctionComponent<Props> = ({ color }) => {
	return (
		<svg width="44" height="57" viewBox="0 0 44 57" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g filter="url(#filter0_d)">
				<path
					d="M40 17.8182C40 27.6589 22 49 22 49C22 49 4 27.6589 4 17.8182C4 7.97747 12.0589 0 22 0C31.9411 0 40 7.97747 40 17.8182Z"
					fill={color}
				/>
			</g>
			<rect x="7.5" y="3.5" width="29" height="29" rx="14.5" fill="var(--text-color)" stroke="white" />
			<path
				d="M30.0684 14.9688H28.1094L27.5449 13.6074C26.9805 12.1797 25.6191 11.25 24.0918 11.25H19.875C18.3477 11.25 16.9863 12.1797 16.4219 13.6074L15.8574 14.9688H13.8984C13.6328 14.9688 13.4336 15.2344 13.5 15.4668L13.6992 16.2637C13.7324 16.4629 13.8984 16.5625 14.0977 16.5625H14.7617C14.2969 16.9609 14.0312 17.5254 14.0312 18.1562V19.75C14.0312 20.3145 14.2305 20.7793 14.5625 21.1445V22.9375C14.5625 23.5352 15.0273 24 15.625 24H16.6875C17.252 24 17.75 23.5352 17.75 22.9375V21.875H26.25V22.9375C26.25 23.5352 26.7148 24 27.3125 24H28.375C28.9395 24 29.4375 23.5352 29.4375 22.9375V21.1445C29.7363 20.7793 29.9688 20.3145 29.9688 19.75V18.1562C29.9688 17.5254 29.6699 16.9609 29.2051 16.5625H29.9023C30.0684 16.5625 30.2344 16.4629 30.2676 16.2637L30.4668 15.4668C30.5332 15.2344 30.334 14.9688 30.0684 14.9688ZM18.3809 14.4043C18.6465 13.7734 19.2109 13.375 19.875 13.375H24.0918C24.7559 13.375 25.3203 13.7734 25.5859 14.4043L26.25 16.0312H17.75L18.3809 14.4043ZM16.6875 19.75C16.0234 19.75 15.625 19.3516 15.625 18.6875C15.625 18.0566 16.0234 17.625 16.6875 17.625C17.3184 17.625 18.2812 18.5879 18.2812 19.2188C18.2812 19.8496 17.3184 19.75 16.6875 19.75ZM27.3125 19.75C26.6484 19.75 25.7188 19.8496 25.7188 19.2188C25.7188 18.5879 26.6484 17.625 27.3125 17.625C27.9434 17.625 28.375 18.0566 28.375 18.6875C28.375 19.3516 27.9434 19.75 27.3125 19.75Z"
				fill={color}
			/>
			<defs>
				<filter
					id="filter0_d"
					x="0"
					y="0"
					width="44"
					height="57"
					filterUnits="userSpaceOnUse"
					color-interpolation-filters="sRGB"
				>
					<feFlood flood-opacity="0" result="BackgroundImageFix" />
					<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
					<feOffset dy="4" />
					<feGaussianBlur stdDeviation="2" />
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
				</filter>
			</defs>
		</svg>
	);
};

export default DriverMarkerSVG;
